import React from 'react';
import { PRStatisticsChart } from './PRStatisticsChart';

interface TaskMetricsProps {
  taskId: string;
}

export const TaskMetrics: React.FC<TaskMetricsProps> = ({ taskId }) => {
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <PRStatisticsChart sourceId={taskId} />
    </div>
  );
};
